import { useContext } from "react";
import { useQuery } from "react-query";
import { AxiosContext } from "services/axios.context";

export const useTrackTypes = () => {
  const { client } = useContext(AxiosContext);
  return useQuery(`track-types`, () => {
    console.debug(`track types retrieved`);
    return client.get(`enums/track_types/`).then((resp) => resp.data);
  });
};
